import { ComponentChildren, createElement } from "preact";
import styles from "./Box.module.scss";

export type BoxBackground =
  | "transparent"
  | "system-red"
  | "blue"
  | "orange"
  | "green"
  | "black"
  | "dark"
  | "light-grey"
  | "grey-black"
  | "purple"
  | "blue-back"
  | "dark";

export type BoxBorder = "none" | "sm" | "md" | "lg" | "xl";

export type BoxPadding = "none" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

export type BoxRadius = "none" | "sm" | "md" | "lg" | "xl";

export interface BoxProps {
  children?: ComponentChildren;
  className?: string;
  style?: Record<string, any>;
  as?: string;
  domRef?: any; // пробрасываем ref к реальному DOM

  // Background
  bg?: BoxBackground;

  // Border
  border?: BoxBorder;
  borderColor?: string;

  // Spacing
  p?: BoxPadding; // padding
  px?: BoxPadding; // padding horizontal
  py?: BoxPadding; // padding vertical
  pt?: BoxPadding; // padding top
  pr?: BoxPadding; // padding right
  pb?: BoxPadding; // padding bottom
  pl?: BoxPadding; // padding left

  // Border radius
  radius?: BoxRadius;

  // Display
  display?:
    | "block"
    | "inline"
    | "inline-block"
    | "flex"
    | "inline-flex"
    | "grid"
    | "none";

  // Flex
  direction?: "row" | "column" | "row-reverse" | "column-reverse";
  justify?: "start" | "end" | "center" | "between" | "around" | "evenly";
  align?: "start" | "end" | "center" | "stretch" | "baseline";
  gap?: BoxPadding;

  // Size
  width?: string;
  height?: string;
  minWidth?: string;
  minHeight?: string;
  maxWidth?: string;
  maxHeight?: string;
}

export function Box({
  children,
  className = "",
  style = {},
  as = "div",
  domRef,
  bg = "transparent",
  border = "none",
  borderColor,
  p,
  px,
  py,
  pt,
  pr,
  pb,
  pl,
  radius = "none",
  display,
  direction,
  justify,
  align,
  gap,
  width,
  height,
  minWidth,
  minHeight,
  maxWidth,
  maxHeight,
}: BoxProps) {
  const boxClasses = [
    styles.box,
    bg !== "transparent" ? styles[`bg-${bg}`] : "",
    border !== "none" ? styles[`border-${border}`] : "",
    radius !== "none" ? styles[`radius-${radius}`] : "",
    p ? styles[`p-${p}`] : "",
    px ? styles[`px-${px}`] : "",
    py ? styles[`py-${py}`] : "",
    pt ? styles[`pt-${pt}`] : "",
    pr ? styles[`pr-${pr}`] : "",
    pb ? styles[`pb-${pb}`] : "",
    pl ? styles[`pl-${pl}`] : "",
    display ? styles[`display-${display}`] : "",
    direction ? styles[`direction-${direction}`] : "",
    justify ? styles[`justify-${justify}`] : "",
    align ? styles[`align-${align}`] : "",
    gap ? styles[`gap-${gap}`] : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const boxStyle = {
    ...style,
    ...(borderColor && { borderColor }),
    ...(width && { width }),
    ...(height && { height }),
    ...(minWidth && { minWidth }),
    ...(minHeight && { minHeight }),
    ...(maxWidth && { maxWidth }),
    ...(maxHeight && { maxHeight }),
  };

  return createElement(
    as,
    {
      className: boxClasses,
      style: boxStyle,
      ref: domRef,
    },
    children
  );
}
